<template>
  <div class="rlt" @click="handleClick">
    <template v-if="disabled">
      <img
        :style="styleSheet"
        src="~@/assets/images/product/new/icon-checkbox-disabled.png"
      />
    </template>
    <template v-else>
      <!-- <input
        class="ys-checkbox"
        type="checkbox"
        v-model="newChecked"
        @change="change($event)"
        :style="styleSheet"
      /> -->
      <img
        :style="styleSheet"
        v-if="newChecked"
        src="~@/assets/images/icon-单选框-选中@3x.png"
      />
      <img
        :style="styleSheet"
        v-else
        src="~@/assets/images/icon-单选框-未选中@3x.png"
      />
    </template>
    <label v-if="label">{{ label }}</label>
  </div>
</template>
<script>
/**
 * uid用来标识checkbox-group组件内item的变更
 * 暂未想到更好的方案
 * 20210201 新增支持v-model绑定
 * */
export default {
  props: {
    value: Boolean,
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, null],
      default: null
    },
    uid: {
      type: [Number, String],
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    styleSheet: Object,
    disabled: Boolean
  },
  data() {
    return {
      newChecked: this.value || this.checked,
      timeSpan: +new Date()
    }
  },
  methods: {
    // change(e) {
    //   const {checked} = e.target
    //   const {uid} = this
    //   this.$emit('input', checked)
    //   this.$emit('onChange', {uid, checked})
    // },
    handleClick() {
      if (this.readOnly) return
      // 手动防抖
      const date = +new Date()
      if (date - this.timeSpan < 300) return
      this.timeSpan = date
      const { uid, disabled, newChecked } = this
      const bool = disabled ? newChecked : !newChecked
      // console.log('checbox status ', bool)
      this.$emit('input', bool)
      this.$emit('onChange', {
        uid,
        checked: bool
      })
    }
  },
  watch: {
    checked(n, o) {
      this.newChecked = n
    },
    value(n, o) {
      this.newChecked = n
    }
  }
}
</script>
<style lang="scss" scoped>
.rlt {
  display: flex;
  align-items: center;
  &::before {
    content: '';
    position: absolute;
    top: -0.24rem;
    bottom: -0.24rem;
    left: -0.24rem;
    right: -0.24rem;
  }
}
.ys-checkbox {
  position: absolute;
  width: 0.44rem;
  height: 0.44rem;
  /* visibility: hidden; */
  opacity: 0;
}
img {
  width: 0.44rem;
  height: 0.44rem;
}
label {
  font-size: 0.28rem;
  color: #121212;
  margin-left: 0.12rem;
}
</style>
